// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import client from '../../sanity/client';
// import './Expositions.scss';
// import { useLanguage } from '../../components/LanguageContext';

// const ExpositionDetail = () => {
//   const { slug } = useParams(); // 🧩 Récupère le slug depuis l'URL
//   const [expo, setExpo] = useState(null);
//   const { language } = useLanguage();
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);

//   const handleResize = () => {
//     setIsMobileView(window.innerWidth <= 992);
//   };

//   const getText = (textObj) => {
//     if (!textObj) return '';
//     return textObj[language] || textObj.fr || '';
//   };

//   useEffect(() => {
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     const fetchExposition = async () => {
//       const query = `*[_type == "expositions"][0].expositions[slug.current == $slug]{
//         title,
//         mainText,
//         secondaryText,
//         gallery[]{ "imageUrl": asset->url + "?auto=format" }
//       }[0]`; // 🧠 On récupère uniquement la première correspondance
//       const result = await client.fetch(query, { slug });
//       setExpo(result);
//     };

//     fetchExposition();
//   }, [slug]);

//   if (!expo) return <div>Loading...</div>;

//   return (
//     <div id='expositions' className="subpage-transmission mobile-title">
//       <div className="exposition-item">
//         {isMobileView ? (
//           <>
//             <div className="text-content-h1">
//               <h1 className='padding-title'>{expo.title?.[language] || expo.title || 'Sans titre'}</h1>
//             </div>
//             <div className="image-content">
//               {expo.gallery?.map((img, idx) => (
//                 <img key={idx} src={img.imageUrl} alt={`Image ${idx}`} className="gallery-image" />
//               ))}
//             </div>
//             <div className="text-content">
//               <div className="text-content-1">
//                 {getText(expo.mainText).split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))}
//               </div>
//               <div className="text-content-1">
//                 {getText(expo.secondaryText).split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))}
//               </div>
//             </div>
//           </>
//         ) : (
//           <>
//             <div className="image-content image-padding-exception">
//               {expo.gallery?.map((img, idx) => (
//                 <img key={idx} src={img.imageUrl} alt={`Image ${idx}`} className="gallery-image" />
//               ))}
//             </div>
//             <div className="text-content sticky">
//               <div className="text-content-h1">
//                 <h1>{expo.title?.[language] || expo.title || 'Sans titre'}</h1>
//               </div>
//               <div className="text-content-1">
//                 {getText(expo.mainText).split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))}
//               </div>
//               <div className="text-content-1">
//                 {getText(expo.secondaryText).split('\n').map((line, idx) => (
//                   <span key={idx}>{line}<br /></span>
//                 ))}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ExpositionDetail;

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import client from '../../sanity/client';
import './Expositions.scss';
import { useLanguage } from '../../components/LanguageContext';

const ExpositionDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [expo, setExpo] = useState(null);
  const { language } = useLanguage();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);

  const handleResize = () => {
    setIsMobileView(window.innerWidth <= 992);
  };

  const getText = (textObj) => {
    if (!textObj) return '';
    return textObj[language] || textObj.fr || '';
  };

  // ✅ NOUVEAU : Gérer le retour navigateur natif
  useEffect(() => {
    const handlePopState = (event) => {
      // Sauvegarder la position actuelle avant de partir
      const currentPosition = window.scrollY;
      sessionStorage.setItem('expositionScrollPosition', currentPosition.toString());
      
      // Naviguer vers /chemin avec état de restauration
      navigate('/chemin', { 
        state: { 
          scrollTo: 'expositions',
          preserveScroll: true 
        },
        replace: true
      });
    };

    // ✅ Sauvegarder position au démontage du composant
    const handleBeforeUnload = () => {
      const currentPosition = window.scrollY;
      sessionStorage.setItem('expositionScrollPosition', currentPosition.toString());
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);

    // ✅ Sauvegarder aussi au démontage React
    return () => {
      const currentPosition = window.scrollY;
      sessionStorage.setItem('expositionScrollPosition', currentPosition.toString());
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigate]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchExposition = async () => {
      const query = `*[_type == "expositions"][0].expositions[slug.current == $slug]{
        title,
        mainText,
        secondaryText,
        gallery[]{ "imageUrl": asset->url + "?auto=format" }
      }[0]`;
      const result = await client.fetch(query, { slug });
      setExpo(result);
    };

    fetchExposition();
  }, [slug]);

  if (!expo) return <div>Loading...</div>;

  return (
    <div id='expositions' className="subpage-transmission mobile-title">
      <div className="exposition-item">
        {/* ... ton code JSX existant reste identique ... */}
        {isMobileView ? (
          <>
            <div className="text-content-h1">
              <h1 className='padding-title'>{expo.title?.[language] || expo.title || 'Sans titre'}</h1>
            </div>
            <div className="image-content">
              {expo.gallery?.map((img, idx) => (
                <img key={idx} src={img.imageUrl} alt={`Exposition ${expo.title?.[language] || expo.title?.fr} - ${idx + 1}`} className="gallery-image" />
              ))}
            </div>
            <div className="text-content">
              <div className="text-content-1">
                {getText(expo.mainText).split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </div>
              <div className="text-content-1">
                {getText(expo.secondaryText).split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="image-content image-padding-exception">
              {expo.gallery?.map((img, idx) => (
                <img key={idx} src={img.imageUrl} alt={`Galerie ${expo.title?.[language] || expo.title?.fr} - ${idx + 1}`} className="gallery-image" />
              ))}
            </div>
            <div className="text-content sticky">
              <div className="text-content-h1">
                <h1>{expo.title?.[language] || expo.title || 'Sans titre'}</h1>
              </div>
              <div className="text-content-1">
                {getText(expo.mainText).split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </div>
              <div className="text-content-1">
                {getText(expo.secondaryText).split('\n').map((line, idx) => (
                  <span key={idx}>{line}<br /></span>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ExpositionDetail;
